const adminPanelDictES = {
  adminPanelSectionMain: "Principal",
  adminPanelSectionSales: "Ventas",
  adminPanelSectionCatalog: "Catálogo",
  adminPanelSectionFinance: "Finanzas",
  adminPanelSectionStorefront: "Tienda y marketing",
  adminPanelUserLists: "Listas de usuarios",
  adminPanelBanners: "Banners",
  adminPanelSearchMenu: "Buscar en el menú",
  adminPanelNoMenuResults: "No se encontraron elementos",
  adminPanelOpenMenu: "Abrir menú",
  adminPanelBeta: "Beta",
  adminPanelUseClassic: "Volver al admin clásico",
  adminPanelTryNew: "Probar el nuevo admin",
  adminPanelChooseTitle: "¿Qué versión del admin quieres usar?",
  adminPanelChooseSubtitle:
    "Estamos migrando el panel administrativo a un nuevo diseño. Ambas versiones tienen las mismas funcionalidades.",
  adminPanelNewVersion: "Nuevo admin",
  adminPanelNewVersionDescription: "Diseño moderno, menú organizado por área y búsqueda rápida.",
  adminPanelClassicVersion: "Admin clásico",
  adminPanelClassicVersionDescription: "El panel de siempre, sin cambios.",
  adminPanelChooseHint: "Tu elección vale hasta que cierres sesión. Puedes cambiar de versión en cualquier momento con el botón en la parte superior.",

  // Home
  adminHomeNeedsAttention: "Requiere atención",
  adminHomeNeedsAttentionHint: "Pendientes actuales, independientes del período seleccionado",
  adminHomeAllClear: "Todo al día",
  adminHomePendingBankTransfers: "Transferencias bancarias por confirmar",
  adminHomePendingOrders: "Pedidos con pendientes",
  adminHomePendingWithdraws: "Retiros en procesamiento",
  adminHomePendingBangood: "Pedidos Bangood sin procesar",
  adminHomePendingPhysicalStores: "Tiendas físicas por verificar",
  adminHomeIndicators: "Indicadores",
  adminHomeCustomPeriod: "Período personalizado",
  adminHomeGroupRevenue: "Ingresos",
  adminHomeGroupOperation: "Operación",
  adminHomeGroupWithdraws: "Retiros",
  adminHomeTotalUsers: "usuarios en total",
  adminHomeTotalProducts: "productos en total",

  // Listas de usuários
  adminUsersStatusAll: "Todos",
  adminUsersStatusActive: "Activos",
  adminUsersStatusBlocked: "Bloqueados",
  adminUsersStatusCancelled: "Cancelados",
  adminUsersStatusFilter: "Filtrar por estado",
  adminUsersSearchPlaceholder: "Buscar por nombre, username, e-mail, teléfono o referente",
  adminUsersCreatedBetween: "Fecha de registro",
  adminUsersClearFilters: "Limpiar filtros",
  adminUsersResults: "resultado(s)",
  adminUsersUser: "Usuario",
  adminUsersContact: "Contacto",
  adminUsersLoadError: "No se pudieron cargar los usuarios.",
  adminUsersRetry: "Intentar de nuevo",
  adminUsersNoResults: "Ningún usuario coincide con estos filtros.",
  adminUsersEmpty: "No hay usuarios registrados en esta lista.",

  // Listas e filas
  adminListCopy: "Copiar",
  adminListCopied: "¡Copiado!",
  adminListLoadError: "No se pudo cargar la lista.",
  adminListNoResults: "Ningún elemento coincide con esta búsqueda.",
  adminListEmpty: "No hay elementos en esta lista.",
  adminWithdrawDestination: "Destino",
  adminWithdrawNoPending: "Ningún retiro pendiente de procesar.",
  adminBankTransferSearch: "Buscar por username o plan",
  adminBankTransferPending: "pendiente(s)",
  adminBankTransferNone: "Ninguna transferencia pendiente de confirmación.",
  adminBankTransferConfirmMessage: "¿Confirmar la recepción de esta transferencia y activar el registro del usuario?",
  adminBankTransferAuthorized: "¡Transferencia autorizada con éxito!",

  // Pedidos e pendências
  adminOrdersOrder: "Pedido",
  adminOrdersItems: "artículo(s)",
  adminOrdersAwaitingShipment: "Esperando envío",
  adminOrdersSearchPlaceholder: "Buscar por nº de pedido, comprador, vendedor o tienda",
  adminPendingSearchPlaceholder: "Buscar por nº de pedido o comprador",
  adminPendingDownloadReceipt: "Descargar comprobante",
  adminPendingConfirmMessage: "¿Confirmar que se recibió la transferencia bancaria de este pedido?",
  adminWithdrawRequestedShort: "Solicitado",

  // Catálogo e formulários
  adminFormSave: "Guardar",
  adminFormTranslations: "Nombre en cada idioma",
  adminFormRequired: "Campo obligatorio",
  adminFormImageHint: "Una imagen, hasta {mb} MB",
  adminFormImageInvalid: "Elige un archivo de imagen.",
  adminFormImageChoose: "Elegir imagen",
  adminFormImageReplace: "Cambiar imagen",
  adminFormImageKeepCurrent: "Mantener la imagen actual",
  adminFormImageRemove: "Quitar",
  adminFormImageDrop: "o arrastra la imagen aquí",
  adminCatalogCategories: "Categorías",
  adminCatalogSubcategories: "Subcategorías",
  adminCatalogEditCategory: "Editar categoría",
  adminCatalogEditSubcategory: "Editar subcategoría",
  adminCatalogEditBrand: "Editar marca",
  adminCatalogEditType: "Editar tipo",
  adminCatalogSaved: "¡Guardado con éxito!",
  adminCatalogSearchName: "Buscar por nombre en cualquier idioma",
  adminCatalogSearchSubcategory: "Buscar por subcategoría o categoría",
  adminCatalogViewInStore: "Ver en la tienda",
  adminCatalogChooseCategory: "Elige la categoría",
  adminCatalogKind: "Tipo de ítem",
  adminCatalogService: "Servicio",
  adminCatalogProduct: "Producto",
  adminCatalogChooseSubcategories: "Elige las subcategorías",
  adminCatalogAddSubcategories: "Añadir subcategorías",
  adminCatalogLinkedSubcategories: "Subcategorías ya vinculadas",
  adminCatalogLinkHint: "Los vínculos existentes no se pueden quitar aquí.",
  adminCatalogLinkFailed: "Se guardó, pero algunas subcategorías no se pudieron vincular. Edita el ítem para intentarlo de nuevo.",
  adminProductsSearch: "Buscar por nº, título o vendedor",

  // Relatórios
  adminReportsThisMonth: "Este mes",
  adminReportsLastMonth: "Mes pasado",
  adminReportsThisYear: "Este año",
  adminReportsExportPdf: "Exportar PDF",
  adminReportsOrdersCount: "Pedidos en el período",
  adminReportsPlatformRevenue: "Ingresos de la plataforma",
  adminReportsOnHoldCount: "en espera",
  adminReportsSearchOrders: "Buscar por nº, comprador, vendedor, CF/P.IVA o estado",
  adminReportsOrderShort: "Pedido",
  adminReportsPaymentMethods: "Formas de pago",
  adminReportsInvoices: "Facturas",
  adminReportsBuyerShort: "Comprador",
  adminReportsSellerShort: "Vendedor",
  adminReportsInvoicingOn: "Activado",
  adminReportsInvoicingOff: "Desactivado",
  adminReportsSubscriptionsCount: "Suscripciones en el período",
  adminReportsTotalPaid: "Total pagado",
  adminReportsSearchSubscriptions: "Buscar por nombre, documento, dirección o forma de pago",
  adminReportsWithdrawalsCount: "Retiros en el período",
  adminReportsSearchWithdrawals: "Buscar por nombre, e-mail, PayPal o IBAN",

  // Lojas físicas e Bangood
  adminStoresSearch: "Buscar por tienda, responsable, dirección o CF/P.IVA",
  adminStoresApproveShort: "Aprobar",
  adminStoresClose: "Cerrar",
  adminStoresRejectHint: "El motivo se enviará al responsable de la tienda.",
  adminBangoodToProcess: "Por procesar",
  adminBangoodProcessed: "Procesados",
  adminBangoodNoPending: "Ningún pedido Bangood pendiente de procesar.",

  // Endereços, inscrições pagas e integrações
  adminSubscriptionsSearch: "Buscar por nombre, username o plan",
  adminIntegrationsConfigured: "Configurado",
  adminIntegrationsNotConfigured: "No configurado",
  adminIntegrationsLoadFailed: "No se pudo cargar la configuración actual. Guardar la reemplazará.",
  adminIntegrationsMetaDescription: "Envía los eventos de la tienda al Pixel de Meta (Facebook e Instagram Ads).",
  adminIntegrationsGtmDescription: "Añade el contenedor de Google Tag Manager a las páginas de la tienda.",
  adminIntegrationsGtmHint: "Código del contenedor, en el formato GTM-XXXXXXX.",
  adminAddressMenu: "Direcciones SendCloud",
  adminAddressUserHint: "Elige el tipo y busca por nombre, username, e-mail o ciudad.",
  adminAddressSearchUser: "Buscar usuario",
  adminAddressLoadingUsers: "Cargando usuarios…",
  adminAddressSendcloud: "Dirección en SendCloud",
  adminAddressLoadingAddresses: "Cargando direcciones…",
  adminAddressNotFound: "¿La dirección no aparece en la lista?",
  adminAddressRegisterOnSendcloud: "Registrarla en SendCloud",
  adminAddressLink: "Vincular dirección",
  adminAddressLinkTitle: "Vincular dirección",
  adminAddressConfirmMessage: "¿Vincular esta dirección de remitente de SendCloud al usuario?",
  adminAddressLinked: "¡Dirección vinculada con éxito!",

  // Banners
  adminBannersNew: "Nueva",
  adminBannersDesktop: "Desktop",
  adminBannersMobile: "Móvil",
  adminBannersRatio: "proporción",
  adminBannersApplyTo: "Aplicar en",
  adminBannersAllLanguages: "Todos los idiomas",
  adminBannersBothDevices: "desktop y móvil",
  adminBannersImages: "imágenes",
  adminBannersVisible: "Visible en la tienda",
  adminBannersHidden: "Oculto",
  adminBannersPreview: "Vista previa en la tienda",
  adminBannersRemoveMessage: "El banner se eliminará cuando guardes los cambios.",
  adminBannersSubDelayHint: "El mismo tiempo vale para los tres sub banners.",
  adminBannersRatioHint: "Toda imagen elegida se recorta en la proporción",
  adminBannersUnsaved: "Cambios sin guardar",
  adminBannersAllSaved: "Todo guardado",
  adminBannersSaving: "Guardando…",

  // Whitelabel
  subnetEditedSuccessfully: "¡Subred editada con éxito!",
  editSubnetData: "Editar datos de la subred",
  searchByUsernameNameOrEmail: "Busca por username, nombre o e-mail",
  selectManager: "Selecciona un manager",
  noManagersFound: "No se encontraron managers",
  adminWhitelabelActive: "Activas",
  adminWhitelabelInactive: "Inactivas",
  adminWhitelabelSearch: "Buscar por nombre, descripción, dueño o ID",
  adminWhitelabelTheme: "Tema",
  adminWhitelabelVisualIdentity: "Identidad visual",
  adminWhitelabelFooter: "Pie de página de la tienda",
  adminWhitelabelFaviconHint: "Ícono que aparece en la pestaña del navegador.",
  adminWhitelabelInvalidEmail: "Introduce un e-mail válido.",
  adminWhitelabelThemeEmpty: "Completa al menos un campo para personalizar.",
  adminWhitelabelThemeSaved: "¡Tema personalizado con éxito!",
  adminWhitelabelThemeSaveError: "Error al personalizar el tema.",
  adminWhitelabelThemeLoadError: "Error al cargar el tema actual.",
};

export default adminPanelDictES;
